// Route Code Edited 6/9/26
/**
 * Route Updates[] Handler
 *
 * Disables all input[name="updates[]"] elements in the cart form at the moment
 * the user clicks Route's cloned checkout button, so they are excluded from
 * form serialization when Route (and any checkout interceptors like SCA) proceed
 * to submit. Inputs are re-enabled on bfcache restore so the cart remains
 * functional if the user navigates back.
 *
 * Installation:
 *   Add this script tag at the bottom of layout/theme.liquid (before </body>):
 *   <script src="{{ 'route-updates-handler.js' | asset_url }}" defer></script>
 */
(function RouteUpdatesInputFix() {
  'use strict';

  // --- Configuration ---

  // Apply on every page, not just the cart page.
  const ALL_SURFACES = false;

  // --- Internals ---

  const SEL = {
    clonedButton: '[data-route-cloned-button]',
    updatesInputs: 'input[name="updates[]"]',
  };

  // Track which inputs we disabled so we can restore exactly those.
  let disabledByUs = [];

  function log(msg, level = 'debug') {
    const prefix = '[Route Updates Fix]';
    if (level === 'error') console.error(prefix, msg);
    else if (level === 'warn')  console.warn(prefix, msg);
    else                        console.debug(prefix, msg);
  }

  function disableUpdatesInputs() {
    // Only disable inputs that aren't already disabled by something else.
    disabledByUs = [...document.querySelectorAll(SEL.updatesInputs)]
      .filter(el => !el.disabled);

    disabledByUs.forEach(el => { el.disabled = true; });
    log(`Disabled ${disabledByUs.length} updates[] input(s).`);
  }

  function restoreUpdatesInputs() {
    disabledByUs.forEach(el => { el.disabled = false; });
    log(`Restored ${disabledByUs.length} updates[] input(s).`);
    disabledByUs = [];
  }

  // Re-enable inputs on bfcache restore so the cart page is fully functional
  // if the user hits Back after reaching checkout.
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) {
      log('bfcache restore detected — restoring updates[] inputs.');
      restoreUpdatesInputs();
    }
  });

  function attachListener(button) {
    // Avoid double-binding.
    if (button._routeUpdateFixBound) return;
    button._routeUpdateFixBound = true;

    button.addEventListener('click', () => {
      disableUpdatesInputs();
      log('Route cloned button clicked — updates[] inputs disabled.');
    }, { capture: true });

    log('Listener attached to cloned button:', button);
  }

  function isCartPage() {
    return /\/cart\/?$/.test(window.location.pathname);
  }

  // Scan the DOM for cloned buttons and attach listeners.
  function applyToVisible() {
    if (!ALL_SURFACES && !isCartPage()) return;

    const buttons = [...document.querySelectorAll(SEL.clonedButton)];
    if (!buttons.length) return;

    buttons.forEach(attachListener);
    log(`applyToVisible: found ${buttons.length} cloned button(s).`);
  }

  // Re-runs whenever Route (re)injects its widget.
  const observer = new MutationObserver(mutations => {
    const relevant = mutations.some(m =>
      [...m.addedNodes].some(n =>
        n.nodeType === Node.ELEMENT_NODE &&
        (n.matches?.(SEL.clonedButton) || n.querySelector?.(SEL.clonedButton))
      )
    );
    if (relevant) applyToVisible();
  });

  function init() {
    applyToVisible();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();